import React from "react";

export default function CartSkeleton() {
  return (
    <div className="flex flex-col lg:flex-row justify-between px-6 py-8 gap-6">
      {/* Left: Cart Items */}
      <div className="flex-1 space-y-4">
        <h2 className="text-2xl font-semibold text-red-700">Shopping Cart</h2>

        {/* Cart Box */}
        <div className="bg-white rounded-md shadow p-4 space-y-6">
          {[1, 2].map((_, idx) => (
            <div
              key={idx}
              className="flex justify-between items-start border-b pb-4"
            >
              <div className="flex gap-4">
                {/* Image Skeleton */}
                <div className="w-24 h-20 bg-gray-200 rounded-md animate-pulse"></div>

                <div className="space-y-2">
                  {/* Title */}
                  <div className="h-4 w-32 bg-gray-300 rounded animate-pulse"></div>
                  {/* Price */}
                  <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
                  {/* Quantity Controls */}
                  <div className="flex items-center gap-2 mt-2">
                    <div className="w-8 h-8 bg-gray-300 rounded animate-pulse"></div>
                    <div className="w-8 h-8 bg-gray-300 rounded animate-pulse"></div>
                    <div className="w-8 h-8 bg-gray-300 rounded animate-pulse"></div>
                  </div>
                </div>
              </div>

              {/* Delete Icon Skeleton */}
              <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
            </div>
          ))}
        </div>

        {/* Add More Link */}
        <div className="h-4 w-40 bg-gray-200 rounded animate-pulse mt-2"></div>
      </div>

      {/* Right: Price Details */}
      <div className="w-full lg:w-1/3 space-y-4">
        <div className="bg-white rounded-md shadow p-6 space-y-4">
          <div className="h-5 w-32 bg-gray-300 rounded animate-pulse"></div>

          {[1, 2, 3, 4, 5].map((_, idx) => (
            <div key={idx} className="flex justify-between">
              <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
            </div>
          ))}

          {/* Total */}
          <div className="flex justify-between font-semibold mt-4">
            <div className="h-5 w-32 bg-gray-300 rounded animate-pulse"></div>
            <div className="h-5 w-20 bg-gray-300 rounded animate-pulse"></div>
          </div>

          {/* Checkout Button Skeleton */}
          <div className="h-10 w-full bg-gray-300 rounded animate-pulse mt-4"></div>
        </div>
      </div>
    </div>
  );
}
